export const HeadCellStyle = {
  color: "var(--Gray-600, #475467)",
  fontFamily: "Montserrat",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "18px",
  whiteSpace: "nowrap",
  borderBottom: "1px solid var(--Gray-200, #EAECF0)",
  background: "var(--Gray-50, #F9FAFB)",
  padding: "12px 16px",
};

export const BodyCellStyle = {
  color: "var(--Gray-600, #475467)",
  fontFamily: "Montserrat",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  borderBottom: "1px solid var(--Gray-200, #EAECF0)",
  padding: "16px",
  whiteSpace: "nowrap",
};
